<template>
  <div class="shop">
    <div class="top" style="margin-bottom:10px">
      <el-button
        style="float:right"
        class="search"
        size="small"
        type="primary"
        @click="searchList"
        >搜索</el-button
      >
      <el-input
        style="float:right;margin:0 10px 10px 0;"
        class="search input"
        size="small"
        v-model="cardNum"
        placeholder="红包卡批次号"
        clearable
      ></el-input>
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="codes_id"></el-table-column>
      <el-table-column label="卡号" prop="card_sn"></el-table-column>
      <el-table-column label="是否使用" prop="use_name"></el-table-column>
      <el-table-column label="使用人" prop="username"></el-table-column>
      <el-table-column label="使用时间" prop="use_time"></el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import {
  getLookRedList,
} from '@/api/redpacketManage'
import { API_BASE_URL } from '@/config'
export default {
  components: {},
  data() {
    return {
      cardNum:'', // 搜索批次号
      tableData: [],
      labelPosition: 'right',
      is_export: 0,  //0非导出，1导出
      form: {
        page: 1
      },
      total: 0,
    }
  },
  mounted() {
    this.getLookRedList()
  },
  methods: {
    //获取列表数据
    async getLookRedList() {
      let is_export = this.is_export
      let cardNum = this.cardNum
      let box_id = this.$route.query.box_id
      let url = `page=${this.form.page}&is_export=${is_export}&box_sn=${cardNum}&box_id=${box_id}`
      let res = await getLookRedList(url)
      console.log(res)
      if (res.code === 10000) {
        if(this.is_export==1){
          this.is_export = 0
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
          );
          return;
        }else{
          this.tableData = res.data.data
          this.total = res.data.total
        }
      } else {
        this.$message.error(res.message)
      }
    },
    //搜索
    searchList() {
      this.is_export = 0
      this.form.page = 1
      this.getLookRedList()
    },
    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getLookRedList()
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .top .input {
    width: 150px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
}
</style>
